import React from "react";
import "./contactMe.css";

export default function ContacMe(){
    return (
        <div id="contact" className="contactMe-container">
            <h2 > Have any <span>Questions?</span></h2>
            <p> If my site has piqued your interest, feel free to get in touch for business inquiries, resume requests, or any further questions you may have, and I'll get back to you asap</p>
            <a href="mailto:chuckgibson@live.ca">Contact Me</a>
        </div>
    )
}